import React from 'react';
import { Bullet, PAD, Panel, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { QuadrantPlot } from './visuals';
const POINTS = [{
  label: 'Traditional agency',
  x: 22,
  y: 74
}, {
  label: 'In-house lab model',
  x: 72,
  y: 26
}, {
  label: 'Snakker',
  x: 78,
  y: 78,
  highlight: true
}];
export function RocheLearning() {
  return <SlideFrame data-id="element-269" data-mp="wpre8z40lgt">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-270" data-mp="w7k8hawsmu4">
        <SlideHeader eyebrow="02 — Validation" title="What we learned from" accent="Roche" kicker="Snakker for LEO Pharma" data-id="element-271" data-mp="3i5w35wez9an4" />

        <div className="mt-[3.2vh] grid min-h-0 flex-1 grid-cols-[1.05fr_1fr] gap-[1.4vw]" data-id="element-272" data-mp="396rah6q3kbiv">
          <Reveal delay={0.2} className="flex min-h-0" data-id="element-273" data-mp="3e4kgnzreh5j5">
            <div className="flex min-h-0 w-full flex-col rounded-[0.8vw] border border-white/10 bg-white/[0.035] p-[1.35vw]" data-id="element-274" data-mp="3e76mnuyn7cz9">
              <h3 className={`${t.label} shrink-0 font-semibold uppercase tracking-[0.18em] text-white/70`} data-id="element-275" data-mp="1cdfmavy31qv4">
                Cost vs quality — where the models land
              </h3>
              <div className="mt-[2.2vh] flex min-h-0 flex-1" data-id="element-276" data-mp="9naac5q6jztz">
                <QuadrantPlot points={POINTS} data-id="element-277" data-mp="9ko1m2rjzea6" />
              </div>
            </div>
          </Reveal>

          <div className="grid min-h-0 grid-rows-3 gap-[1.2vh]" data-id="element-278" data-mp="nfq92uc1tbp3">
            <Reveal delay={0.3} className="flex min-h-0" data-id="element-279" data-mp="ifc79u11ixzi">
              <Panel index="01" label="Roche validated the need" className="w-full" data-id="element-280" data-mp="3qu2njac5sunz">
                <Bullet data-id="element-281" data-mp="3mtabk9bwkbo0">
                  Moved toward an in-house / lab model to reduce cost — the objective
                  was right: lower cost, more control, more repeatability
                </Bullet>
              </Panel>
            </Reveal>
            <Reveal delay={0.4} className="flex min-h-0" data-id="element-282" data-mp="3vs46zwdhyvzz">
              <Panel index="02" label="The key learning" className="w-full" data-id="element-283" data-mp="1g21f4kifc4ta">
                <Bullet data-id="element-284" data-mp="1b3ge4ivclh3s">
                  Cost reduction alone was not enough — quality suffered. The missing
                  piece was content strategy and delivery orchestration, not capacity
                </Bullet>
              </Panel>
            </Reveal>
            <Reveal delay={0.5} className="flex min-h-0" data-id="element-285" data-mp="1n46eoimbsu9d">
              <Panel index="03" label="What that means for Snakker" className="w-full" data-id="element-286" data-mp="1s4c4rucy68pc">
                <Bullet data-id="element-287" data-mp="1x3owotioe5ys">
                  No internal content factory is needed to get the value in-housing
                  promised — Snakker reaches the same end goal without a lab model
                </Bullet>
              </Panel>
            </Reveal>
          </div>
        </div>
      </div>
    </SlideFrame>;
}